import { getValue, getFullUrl } from 'utils/utilityHelper'
import ImageList from './ImageList'
import List from "components/kanso/atoms/list/List"
import ListItem from "components/kanso/atoms/list/ListItem"
import Image from 'components/kanso/atoms/image/Image'

const ImageListAcousticData = (props) => {
  const { 
    imageContentItems
  } = props.data

  return (
    <ImageList>
      <List>
        {imageContentItems?.values?.map((content, index) => {
          return (
            <ListItem key={index}>
              <Image src={getFullUrl(content?.elements?.src?.url)} mediaSrc={content?.elements?.src?.asset} altText="" />
            </ListItem>
          )
        })}      
      </List>
    </ImageList>
  )
}

export default ImageListAcousticData